export default "__VITE_ASSET__q0Lva7Dl__"